export default __webpack_public_path__ + "static/media/ana-ult.2e34290d.mp3";